/* eslint-disable import/no-cycle */
import Http from '@/api/http';
/* eslint-enable import/no-cycle */
export default class Application {
    static getApplications() {
        return Http.get('/application/all');
    }

    static getApplicationById(id) {
        return Http.get(`/application/${id}`);
    }

    static addApplication({ app, description }) {
        return Http.post('/application', {
            app,
            description,
        });
    }

    static updateApplication({ app, description, id }) {
        return Http.put(`/application/${id}`, {
            id,
            app,
            description,
        });
    }

    static getPermissions() {
        return Http.get('/application/permission/all');
    }

    static getPermissionById(id) {
        return Http.get(`/application/permission/${id}`);
    }

    static addPermission({ app_id, data, user_id }) {
        return Http.post('/application/permission', {
            app_id,
            data,
            user_id,
        });
    }

    static updatePermission({
        app_id,
        data,
        user_id,
        start_at,
        id,
    }) {
        return Http.put(`/application/permission/${id}`, {
            id,
            app_id,
            data,
            user_id,
            start_at,
        });
    }
}
